import React, { useEffect } from 'react'
import styles from './Notifications.module.scss'

import { useSelector, useDispatch } from 'react-redux'
import NotificationsAPI from '../../../../APIs/notifications'
import { GET_USERS, SET_COUNT } from '../../../../redux/actions/actionTypes'

import NotificationsCard from '../../../../components/NotificationsCard'

const List = () => {
  const dispatch = useDispatch()
  const { search } = useSelector((state) => state.expertsReducer)
  const { users, pagination } = useSelector((state) => state.usersReducer)

  const getUsers = async () => {
    const res = await NotificationsAPI.getNotificartions(search, pagination)
    dispatch({ type: GET_USERS, payload: res.rows })
    dispatch({ type: SET_COUNT, payload: res.count })
  }

  useEffect(() => {
    getUsers()
  }, [search, pagination])

  return (
    <div className={styles.allPROs}>
      <ul>
        {users.map((item) => (
          <li key={item.id}>
            <NotificationsCard data={item} getUsers={getUsers} />
          </li>
        ))}
      </ul>
    </div>
  )
}

export default List
